import React from 'react';
import AnyLink from '../common/anyLink';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { useTablet } from '../../hooks/utilHooks';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { ellipsize } from '../../utils/textUtil';
import ImageIcon from '@material-ui/icons/Image';

const RichLinkPreview = ({ post }) => {
  const classes = useStyles();
  const isTablet = useTablet();

  return (
    <AnyLink to={post.requestedUrl}>
      <Box width={1} px={4}>
        <Box className={classes.imgContainer}>
          {post.ogImageUrl && (
            <img
              src={post.ogImageUrl}
              alt="img"
              className={classes.renderImg}
            />
          )}
          {!post.ogImageUrl && (
            <Box>
              <ImageIcon className={classes.defaultImg} />
            </Box>
          )}
          {post.isVideoLink && (
            <Box className={classes.playIcon}>
              <PlayArrowIcon />
            </Box>
          )}
        </Box>
        <Box className={classes.ogContent}>
          <Typography color="textPrimary" variant="body2" component="div">
            {ellipsize(post.ogTitle, isTablet ? 80 : 120)}
          </Typography>
          {post.ogDescription && (
            <Typography
              color="textPrimary"
              variant="caption"
              className={classes.ogDescription}
            >
              {ellipsize(post.ogDescription, isTablet ? 100 : 160)}
            </Typography>
          )}
        </Box>
      </Box>
    </AnyLink>
  );
};

const useStyles = makeStyles((theme) => ({
  imgContainer: {
    background: theme.palette.background.default,
    height: '240px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  renderImg: {
    maxWidth: '100%',
    height: '100%',
    width: '100%',
    borderTopLeftRadius: theme.spacing(3),
    borderTopRightRadius: theme.spacing(3),
  },
  ogContent: {
    border: '1px solid #dcdcdc',
    borderBottomLeftRadius: theme.spacing(3),
    borderBottomRightRadius: theme.spacing(3),
    margin: theme.spacing(-0.5, 0, 2, 0),
    padding: theme.spacing(1.5, 2, 2),
  },
  ogDescription: {
    fontSize: '11px',
    lineHeight: '16px',
    display: 'inline-block',
    marginTop: theme.spacing(1),
  },
  playIcon: {
    position: 'absolute',
    top: theme.spacing(0),
    left: theme.spacing(0),
    right: theme.spacing(0),
    margin: '0px auto',
    height: '100%',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      fontSize: '30px',
      width: '40px',
      height: '40px',
      background: theme.palette.primary.main,
      color: 'white',
      borderRadius: '50%',
    },
  },
  defaultImg: {
    fontSize: theme.spacing(10),
    opacity: '0.6',
    color: theme.palette.text.primary,
  },
}));

export default RichLinkPreview;
